import React, {Component} from 'react';

type State = any;

class ErrorBoundary extends Component<{}, State> {
    constructor(props: {}) {
        super(props);
        this.state = {
            hasError: false,
            errorMessage: '',
        };
    }
    
    static getDerivedStateFromError(error: any) {
        return {
            hasError: true,
            errorMessage: error.message,
        };
    }
    
    render() {
        const {children} = this.props;
        const {
            hasError,
            errorMessage,
        } = this.state;
        
        if (hasError) {
            return (
                <div>
                    <h1>Error occurred.</h1>
                    <p>{errorMessage}</p>
                </div>
            );
        }
        
        return children;
    }
}

export default ErrorBoundary;
